import { get, post } from "api/axios-client";
import { AxiosProgressEvent } from "axios";
import { SegmentImages } from "components/QueueBoard/models/workOrderTypes";

const controllerUrl = "api/Attachment/";
export interface Slide {
  src: string;
}
export const AttachmentApi = {
  getAttachmentImage: async (imageId: number): Promise<any> => {
    const { data } = await get(`${controllerUrl}`, {
      params: {
        imageId,
      },
      responseType: "blob",
    });
    return data;
  },
  getAttachmentImageThumbnail: async (imageId: number): Promise<any> => {
    const { data } = await get(`${controllerUrl}GetThumbnail`, {
      params: {
        imageId,
      },
      responseType: "blob",
    });
    return data;
  },

  fetchSlideImage: async (imageId: number): Promise<Slide> => {
    const response = await get(`${controllerUrl}${imageId}`, {
      responseType: "blob",
    });
    const imageUrl = URL.createObjectURL(response.data);
    return { src: imageUrl };
  },

  fetchThumbnail: async (imageId: number): Promise<string> => {
    const response = await get(
      `${controllerUrl}GetAttachmentImageThumbnail/${imageId}`,
      {
        responseType: "blob",
      }
    );
    return URL.createObjectURL(response.data);
  },

  downloadAttachment: async (attachmentIdentity: number): Promise<string> => {
    const response = await get(
      `${controllerUrl}GetAttachment/${attachmentIdentity}`,
      {
        responseType: "blob",
        headers: {
          Accept: "*/*",
        },
      }
    );

    return URL.createObjectURL(response.data);
  },
  uploadImage: (
    attachmentObj: FormData,
    onUploadProgress: (progressEvent: AxiosProgressEvent) => void
  ) => {
    return post(`${controllerUrl}UploadSegmentImage`, attachmentObj, {
      onUploadProgress,
    });
  },
  uploadAttachment: (
    attachmentObj: FormData,
    onUploadProgress: (progressEvent: AxiosProgressEvent) => void
  ) => {
    return post(`${controllerUrl}UploadSegmentAttachment`, attachmentObj, {
      onUploadProgress,
    });
  },
  removeAttachedImage: (attachedImageIdentity: number) => {
    return post(
      `${controllerUrl}RemoveSegmentAttachmentImage/${attachedImageIdentity}`
    );
  },
  removeAttachement: (attachmentIdentity: number) => {
    return post(
      `${controllerUrl}RemoveSegmentAttachment/${attachmentIdentity}`
    );
  },
};
